import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import { Optional } from "@/__main__/data-model.mjs";
import { ItemQuantity } from "@/game-fortnite/models/match-player-item-quantity.mjs";
import { PlayerMatchKill } from "@/game-fortnite/models/match-player-kill.mjs";
import { player } from "@/game-fortnite/models/player.mjs";
import { playerWeaponStat } from "@/game-fortnite/models/player-weapon-stats.mjs";

export const PlayerMatch = {
  accuracy: Number,
  accuracyHist: Optional(Number),
  aliveTime: Number,
  aliveTimeHist: Optional(Number),
  assists: Number,
  assistsHist: Optional(Number),
  damageDealt: Number,
  damageDealtHist: Optional(Number),
  damageTaken: Number,
  damageTakenHist: Optional(Number),
  damageToStructures: Number,
  distanceTraveled: Number,
  distanceTraveledHist: Optional(Number),
  downs: Number,
  downsHist: Optional(Number),
  headshotPercentage: Number,
  isLocal: Boolean,
  island: {
    key: String,
    name: String,
  },
  itemQuantities: [ItemQuantity],
  kills: Number,
  killsHist: Optional(Number),
  metalGathered: Number,
  metalGatheredHist: Optional(Number),
  metalUsed: Number,
  placement: Number,
  player,
  playerMatchKills: [PlayerMatchKill],
  revives: Number,
  revivesHist: Optional(Number),
  stoneGathered: Number,
  stoneGatheredHist: Optional(Number),
  stoneUsed: Number,
  team: Number,
  teammateIds: [String],
  totalHeadshots: Number,
  totalHeadshotsHist: Optional(Number),
  totalHits: Number,
  totalHitsHist: Optional(Number),
  woodGathered: Number,
  woodGatheredHist: Optional(Number),
  woodUsed: Number,
  weaponStats: [playerWeaponStat],
  character: Optional(String),
} satisfies ModelDefinition;

export type PlayerMatchBE = FromModel<typeof PlayerMatch>;
